import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMacLaptopNotebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "mac laptop notebook",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.04086 6.42167C4.04086 4.66164 5.46754 3.23633 7.2262 3.23633H17.274C19.0339 3.23633 20.4594 4.66184 20.4594 6.42167V14.2624L21.8168 17.2164C21.8251 17.2344 21.8327 17.2528 21.8395 17.2715C22.4606 18.9664 21.2061 20.7625 19.4005 20.7625H5.09883C3.29458 20.7625 2.03874 18.9678 2.65975 17.2717C2.66662 17.2529 2.67425 17.2344 2.68261 17.2162L4.04086 14.2623V6.42167ZM7.2262 4.73633C6.29557 4.73633 5.54086 5.49046 5.54086 6.42167V14.4265C5.54086 14.5347 5.51746 14.6416 5.47227 14.7398L4.05955 17.8122C3.8181 18.5216 4.34517 19.2625 5.09883 19.2625H19.4005C20.1548 19.2625 20.6813 18.5209 20.4398 17.8122L19.0279 14.7397C18.9827 14.6414 18.9594 14.5346 18.9594 14.4265V6.42167C18.9594 5.49027 18.2054 4.73633 17.274 4.73633H7.2262Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1934 17.2539C10.1934 16.8397 10.5291 16.5039 10.9434 16.5039H13.5587C13.9729 16.5039 14.3087 16.8397 14.3087 17.2539C14.3087 17.6681 13.9729 18.0039 13.5587 18.0039H10.9434C10.5291 18.0039 10.1934 17.6681 10.1934 17.2539Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.05859 14.4277C4.05859 14.0135 4.39438 13.6777 4.80859 13.6777H19.6931C20.1073 13.6777 20.4431 14.0135 20.4431 14.4277C20.4431 14.8419 20.1073 15.1777 19.6931 15.1777H4.80859C4.39438 15.1777 4.05859 14.8419 4.05859 14.4277Z",
			fill: "currentColor"
		})
	]
});
export default SvgMacLaptopNotebook;
